import postBubbleView from './postBubbleComponent.html';
import './postBubbleComponent.css';
import { AssetManager } from 'components/sharpr/assetManager/AssetManager';

export function postBubbleComponent() {
	return {
		bindings: {
			post: '=',
			size: '@?',
		},
		controllerAs: 'vm',
		controller: postBubbleComponentCtrl,
		template: postBubbleView,
	};
}

export class postBubbleComponentCtrl {
	constructor() {
		'ngInject';
		AssetManager.loadBubbleCss(this.post);
	}
}
